import { Loader } from "@sicredi/react";
import React, { lazy, Suspense } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

import { PAGINAS } from "#/constants";
import { OidcSecure } from "@axa-fr/react-oidc";

const LazyHome = lazy(() => import("#/containers/Home"));
const LazyOnboarding = lazy(() => import("#/containers/Onboarding"));
const LazyRecuperacao = lazy(() => import("./Recuperacao"));
const LazyAcompanhamentoProposta = lazy(
  () => import("./AcompanhamentoProposta")
);
const LazyNotFound = lazy(() => import("#/containers/NotFound"));
const LazyOfertas = lazy(() => import("./Ofertas"));

const LazyRotasSimulacao = lazy(() => import("./Simulacao"));
const LazyRotasFeedback = lazy(() => import("./Feedback"));
const LazyRotasEfetivacao = lazy(() => import("./Efetivacao"));

export const Routes: React.FC = () => (
  <Router basename={process.env.PUBLIC_URL}>
    <Suspense fallback={<Loader show fullScreen />}>
      <Switch>
        <Route exact path={PAGINAS.ONBOARDING()} component={LazyOnboarding} />
        <OidcSecure>
          <Route exact path={PAGINAS.ROOT()} component={LazyHome} />
          <Route
            path={PAGINAS.RECUPERACAO.ROOT()}
            component={LazyRecuperacao}
          />
          <Route path={PAGINAS.OFERTAS.ROOT()} component={LazyOfertas} />
          <Route
            path={PAGINAS.SIMULACAO.ROOT()}
            component={LazyRotasSimulacao}
          />
          <Route path={PAGINAS.FEEDBACK.ROOT()} component={LazyRotasFeedback} />
          <Route
            path={PAGINAS.EFETIVACAO.ROOT()}
            component={LazyRotasEfetivacao}
          />
          <Route
            path={PAGINAS.ACOMPANHAMENTO.ROOT()}
            component={LazyAcompanhamentoProposta}
          />
        </OidcSecure>
        <Route path="*" component={LazyNotFound} />
      </Switch>
    </Suspense>
  </Router>
);
export default Routes;
